import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const visitPage = createAction('visitCentralizedDispatchPage');
export const setReports = createAction('setCentralizedDispatchReports');
export const setUsedReport = createAction('setCentralizedDispatchUsedReport');
export const getReportsRequest = createAction('getCentralizedDispatchReportsRequest');
export const setTripsOrderFields = createAction('setCentralizedDispatchTripsOrderFields');
export const createReportRequest = createAction('createCentralizedDispatchReportRequest');
export const deleteReportRequest = createAction('deleteCentralizedDispatchReportRequest');
export const updateReportRequest = createAction('updateCentralizedDispatchReportRequest');
export const setTripsSearchCriteria = createAction('setCentralizedDispatchTripsSearchCriteria');
export const setDriversSearchCriteria = createAction('setCentralizedDispatchDriversSearchCriteria');
export const setDriversRadiusRequestParams = createAction('setCentralizedDispatchDriversRadiusRequestParams');
